<template>
  <el-card>
    <el-form label-width="auto" :model="formData" ref="form" :rules="rules">
      <el-form-item label="标题：" prop="name">
        <el-input placeholder="标题" v-model="formData.name" />
      </el-form-item>

      <el-form-item label="内容：" prop="content">
        <wangeditor ref="editor" :upload-img-server="$api.file.uploadEditor" v-model="formData.content" />
      </el-form-item>

<!--      <el-form-item label="发布时间：">-->
<!--        <el-input placeholder="发布时间" />-->
<!--      </el-form-item>-->

      <el-form-item>
        <el-button type="primary" @click="handleConfirm">确认</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import Wangeditor from "@/components/Wangeditor";
import {request} from "@/config/request";
import {resetEmpty} from "@/utils/common";
export default {
  name: "FAQEdit",
  components: {Wangeditor},
  data() {
    return {
      formData: {
        name: "",
        content: "",
        expand: "",
        sort: null
      },
      rules: {
        name: {required: true, message: "请输入标题", trigger: "blur"},
        content: {required: true, message: "请输入内容", trigger: "blur"}
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate(async valid => {
        if(!valid) return;
        try {
          const params = {
            ...this.formData,
            code: this.$route.query.code,
          }
          delete params.releaseTime;
          await request(this.$api.questionSort.updateQuestion, params);
          this.$message.success("操作成功");
          this.$router.back();
        } catch (e) {
          console.log(e);
        }
        console.log("HH")
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
      this.$refs.editor.clear();
    },

    async loadDetail() {
      try {
        const res = await request(this.$api.questionSort.detail, this.$route.query);
        const form = res.questionSort;
        delete form.createTime;
        delete form.updateTime;
        this.formData = {...form};
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>

.el-form {
  max-width: 800px;
}

</style>
